import { createAction, props } from '@ngrx/store';
import { PhotoSource } from '@fc-vehicles/components/dialogs/vehicle-photo-upload-dialog/uploaded-list/photo.source';
import { VehicleAttachmentModel } from '@fc-vehicles/models/vehicle-attachment-model';

export const loadVehiclePhotos = createAction(
  '[VehiclePhoto] Load VehiclePhotos',
  props<{ vehicleId: number }>(),
);

export const loadVehiclePhotosSuccess = createAction(
  '[VehiclePhoto] Load VehiclePhotos Success',
  props<{ photos: VehicleAttachmentModel[] }>(),
);

export const updateVehiclePhoto = createAction(
  '[VehiclePhoto] Update VehiclePhotos',
  props<{
    photoId: number;
    vehicleId: number;
    fields: { [key: string]: any };
  }>(),
);

export const updateVehiclePhotoSuccess = createAction(
  '[VehiclePhoto] Update VehiclePhotos Success',
  props<{ photo: VehicleAttachmentModel; fields: any }>(),
);
export const deleteVehiclePhoto = createAction(
  '[VehiclePhoto] Delete VehiclePhotos',
  props<{ photo: VehicleAttachmentModel }>(),
);

export const deleteSelectedVehiclePhotos = createAction(
  '[VehiclePhoto] Delete Selected VehiclePhotos',
  props<{ photos: VehicleAttachmentModel[] }>(),
);

export const deleteSelectedVehiclePhotosSuccess = createAction(
  '[VehiclePhoto] Delete Selected VehiclePhotos Success',
  props<{ photos: VehicleAttachmentModel[] }>(),
);

export const deleteVehiclePhotoSuccess = createAction(
  '[VehiclePhoto] Delete VehiclePhotos Success',
  props<{ photo: VehicleAttachmentModel }>(),
);
export const uploadVehiclePhoto = createAction(
  '[VehiclePhoto] Upload VehiclePhotos',
  props<{ sources: PhotoSource[]; vehicleId: number }>(),
);
export const uploadVehiclePhotoSuccess = createAction(
  '[VehiclePhoto] Upload VehiclePhotos Success',
  props<{ photos: VehicleAttachmentModel[] }>(),
);

export const addTempPhotos = createAction(
  '[VehiclePhoto] Add Temp Photos',
  props<{ photos: File[] }>(),
);

export const loadVehiclePhotosFailure = createAction(
  '[VehiclePhoto] Load VehiclePhotos Failure',
  props<{ error: any }>(),
);
